module.exports = __webpack_public_path__ + "img/gift1-pc.61d4f068.png";